module.exports = __webpack_public_path__ + "img/r10.18f12ae7.jpg";